import React from 'react';
import { Card, Skeleton, Space, Row, Col } from 'antd';

/**
 * 产品卡片骨架屏
 * 
 */
const ProductCardSkeleton: React.FC = () => {
  return (
    <Card
      style={{ height: '100%' }}
      cover={
        <div style={{ padding: 12, background: 'rgba(0,0,0,0.2)', height: 180, borderRadius: '8px 8px 0 0' }}>
          <Skeleton.Image 
            active 
            style={{ width: '100%', height: '100%' }} 
          />
        </div>
      }
      actions={[
        <Skeleton.Button active size="small" key="1" />,
        <Skeleton.Button active size="small" key="2" />,
      ]}
    >
      <Skeleton active paragraph={{ rows: 3 }} />
    </Card>
  );
};

/**
 * 产品卡片骨架屏网格
 * 
 * @param count - 显示的骨架屏数量
 */
export const ProductGridSkeleton: React.FC<{ count?: number }> = ({ count = 12 }) => {
  return (
    <Row gutter={[16, 16]}>
      {Array.from({ length: count }).map((_, index) => (
        <Col xs={24} sm={12} md={8} lg={6} xl={4} key={index}>
          <ProductCardSkeleton />
        </Col>
      ))}
    </Row>
  );
};

/**
 * 统计信息骨架屏
 */
export const StatisticsSkeleton: React.FC = () => {
  return (
    <Space>
      <Skeleton.Input active size="small" style={{ width: 80 }} />
      <Skeleton.Input active size="small" style={{ width: 60 }} />
      <Skeleton.Input active size="small" style={{ width: 60 }} />
    </Space>
  );
};

export default ProductCardSkeleton;
